import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaDeteccionRiesgosInterface } from "../../../../../interfaces/FechaDeteccionRiesgosInterface";
import { SemaforoDRInterface } from "../../../../../interfaces/SemaforoDRInterface";
import { NotasConclusionDRInterface } from "../../../../../interfaces/NotasConclusionDRInterface";
import { ResultadoDRInterface } from "../../../../../interfaces/ResultadoDRInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Checkbox, Label, Textarea, TextInput } from "flowbite-react";
import SkyClear from "../../../../../img/SkyClear.png";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ConclusionesDREditarScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CONCLUSIONES DE EVALUACIÓN DE DETECCIÓN DE RIESGOS";
  const { control, reset, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const resetFormData = () => {
    const emptyFormData = {
      visitDate: "",
      name: "",
      rfc: "",
      sex: "",
      civilStatus: "",
      education: "",
      birthDate: "",
      curp: "",
      company: "",
    };
    setImages([""]);
    localStorage.removeItem("images");
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...images];
        newImages[index] = reader.result as string;
        setImages(newImages);

        localStorage.setItem("images", JSON.stringify(newImages));
      };
      reader.readAsDataURL(file);
    }
  };

  const addImageBox = () => {
    setImages([...images, ""]);
    setNotes([...notes, ""]);
  };

  const removeImage = (index: number) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedNotes = notes.filter((_, i) => i !== index);
    setImages(updatedImages);
    setNotes(updatedNotes);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const handleNoteChange = (
    index: number,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = event.target.value;
    setNotes(updatedNotes);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechaDeteccionRiesgosInterface>({
    url: `/fecha-deteccion-riesgos/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-deteccion-riesgos"],
  });

  const mutateFecha = useMutationData({
    url: `/fecha-deteccion-riesgos/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-deteccion-riesgos"],
  });

  const queryNotasDR = useGetData<NotasConclusionDRInterface[]>({
    url: `/notas-conclusion/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "notas-conclusion"],
  });

  const mutateNotasDR = useMutationData({
    url: `/notas-conclusion/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "notas-conclusion"],
  });

  const queryResultadoDR = useGetData<ResultadoDRInterface[]>({
    url: `/resultado-conclusion/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "resultado-conclusion"],
  });

  const mutateResultadoDR = useMutationData({
    url: `/resultado-conclusion/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "resultado-conclusion"],
  });

  const querySemaforoDR = useGetData<SemaforoDRInterface>({
    url: `/semaforoDR/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforoDR"],
  });

  const mutateSemaforoDR = useMutationData({
    url: `/semaforoDR/${evaluadosList_id}`,
    reload: ["evaluado", "semaforoDR", `${evaluadosList_id}`],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFecha.data) {
      reset({
        fecha_conclusionesdr: queryFecha.data.fecha_conclusionesdr || "",
        evaluado_uuid: queryFecha.data.evaluado_uuid || "",
      });
    }
  }, [queryFecha.data, reset]);

  useEffect(() => {
    if (queryNotasDR.data && queryNotasDR.data.length > 0) {
      const notadr = queryNotasDR.data[0];
      reset({
        nota_conclusion: notadr.nota_conclusion || "",
        evaluado_uuid: notadr.evaluado_uuid || "",
      });
    }
  }, [queryNotasDR.data, reset]);

  useEffect(() => {
    if (queryResultadoDR.data && queryResultadoDR.data.length > 0) {
      const resultadodr = queryResultadoDR.data[0];
      reset({
        resultado_conclusion: resultadodr.resultado_conclusion || "",
        evaluado_uuid: resultadodr.evaluado_uuid || "",
      });
    }
  }, [queryNotasDR.data, reset]);

  useEffect(() => {
    if (querySemaforoDR.data) {
      const color = querySemaforoDR.data.color_dr || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_dr: color,
        evaluado_uuid: querySemaforoDR.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoDR.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-900"}`}>
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_conclusionesdr" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
            FECHA EVALUACIÓN:
          </Label>
          <Controller
            name="fecha_conclusionesdr"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_conclusionesdr"
                type="date"
                value={queryFecha.data?.fecha_conclusionesdr}
                className={`text-center w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
              />
            )}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
          />
        </div>

        {/* FOTO */}
        <div className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${isDarkMode ? "border-gray-600 bg-gray-800" : "border-gray-300 bg-gray-100"}`}>
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span className={`text-gray-500 ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>Sin foto disponible</span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label className={`flex items-center gap-2 mt-4 mb-4 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                checked={selectedRecommendation === "recomendable"}
                onChange={handleRadioChange}
                className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
              />
              RECOMENDABLE
            </label>
            <label className={`flex items-center gap-2 mt-12 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                checked={selectedRecommendation === "con_reserva"}
                onChange={handleRadioChange}
                className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
              />
              CON RESERVA
            </label>
            <label className={`flex items-center gap-2 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                checked={selectedRecommendation === "no_recomendable"}
                onChange={handleRadioChange}
                className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-900 text-white" : "bg-gray-50"}`}>
      <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-900 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">
          CONCLUSIONES DE EVALUACIÓN DE VISITA DOMICILIARIA
        </h2>
      </div>

      <div className={`flex flex-col items-center border-dashed border-4 rounded-lg p-8 space-y-4 relative ${isDarkMode ? "border-gray-600 bg-gray-800" : "border-gray-300 bg-gray-100"}`}>
        {/* Área para agregar notas */}
        <div className="w-full mt-4">
          <Controller
            name="nota_conclusion"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                id="nota_conclusion"
                value={
                  field.value ||
                  (queryNotasDR.data && queryNotasDR.data.length > 0
                    ? queryNotasDR.data[0]?.nota_conclusion || ""
                    : "")
                }
                onChange={(e) => field.onChange(e.target.value)}
                className={`w-full border rounded-lg p-2 focus:outline-none focus:border-blue-500 ${isDarkMode ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"}`}
                rows={4}
              />
            )}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Campo Resultado */}
        <div className="col-span-1">
          <Label htmlFor="resultado_conclusion" className={isDarkMode ? "text-gray-200" : "text-gray-900"}>RESULTADO:</Label>
          <Controller
            name="resultado_conclusion"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="resultado_conclusion"
                type="text"
                value={
                  field.value ||
                  (queryResultadoDR.data && queryResultadoDR.data.length > 0
                    ? queryResultadoDR.data[0]?.resultado_conclusion || ""
                    : "")
                }
                onChange={(e) => field.onChange(e.target.value)}
                className={`text-center w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
              />
            )}
          />
        </div>
      </div>
    </div>
  );


  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            const formData = {
              ...data,
              recomendacion: selectedRecommendation,
              color_dr:
                selectedRecommendation === "recomendable"
                  ? "verde"
                  : selectedRecommendation === "con_reserva"
                  ? "amarillo"
                  : selectedRecommendation === "no_recomendable"
                  ? "rojo"
                  : "",
            };

            mutateFecha.mutate(
              {
                data: { fecha_conclusionesdr: data.fecha_conclusionesdr },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  mutateSemaforoDR.mutate(
                    {
                      data: formData,
                      tipo: "put",
                    },
                    {
                      onSuccess: () => {
                        mutateNotasDR.mutate(
                          {
                            data: formData,
                            tipo: "put",
                          },
                          {
                            onSuccess: () => {
                              mutateResultadoDR.mutate(
                                {
                                  data: formData,
                                  tipo: "put",
                                },
                                {
                                  onSuccess: () => {
                                    navigate(`/poligrafo/${evaluadosList_id}`);
                                  },
                                  onError: (error) => {
                                    console.error(
                                      "Error al guardar Notas DR:",
                                      error
                                    );
                                  },
                                }
                              );
                            },
                            onError: (error) => {
                              console.error(
                                "Error al guardar Resultado DR:",
                                error
                              );
                            },
                          }
                        );
                      },
                      onError: (error) => {
                        console.error("Error al guardar Semáforo DR:", error);
                      },
                    }
                  );
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Detección de Riesgos:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className="mt-6 p-4 flex justify-between">
            {/* Botón Cancelar */}
            {currentPage === 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/poligrafo/${evaluadosList_id}`);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-700 hover:bg-red-800 text-white" : "bg-red-500 hover:bg-red-600 text-white"}`}
              >
                Cancelar
              </Button>
            )}

            {/* Botón Siguiente */}
            {currentPage === 1 && (
              <Button
                className={`ml-2 ${isDarkMode ? "bg-blue-700 hover:bg-blue-800 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"}`}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Siguiente
              </Button>
            )}

            {currentPage > 1 && (
              <Button
                onClick={() => handlePageChange(currentPage - 1)}
                className={`ml-2 ${isDarkMode ? "bg-violet-700 hover:bg-violet-800 text-white" : "bg-violet-500 hover:bg-violet-600 text-white"}`}
              >
                Anterior
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <Button
                  type="submit"
                  className={`ml-2 ${isDarkMode ? "bg-green-700 hover:bg-green-800 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
                >
                  Guardar
                </Button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
